type Payload = {
  locale: string;
  id: string;
};

type Response = {
  player: any;
  token: string;
};

export const guestSignInOnOnboardingRequest = async (data: Payload): Promise<Response> => {
  const response = await fetch(`${process.env.BASE_URL_V1}${process.env.PREFIX_URL_V1}/auth/guest`, {
    method: 'POST',
    headers: {
      Accept: process.env.REQUEST_ACCEPT_HEADER_V1 || '',
      'content-type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(data),
  });

  return await response.json();
};
